import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  all: [],
  slots: [],
};

export default function teamReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.TEAMS_FETCH:
      return {
        ...state,
        all: payload,
      };
    case ActionTypes.SLOTS_FETCH:
      return {
        ...state,
        slots: payload,
      };
    default:
      return state;
  }
}
